import React from 'react';
import './learn.css';
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed
import { useLanguage } from '../../LanguageContext';

function LearnMore() {
const { language } = useLanguage();

  return (
    <div className='learn'>
      <div className='message'>
        <span className={language === 'es' ? 'spanish-styling spanish-smaller' : ''}>
          <TranslateText text="Tradelines are the smartest and fastest way to boost your credit score." />
        </span>
      </div>
        
      
      <div className='buttonBox'>
        <button className='buttonLook'>
          <TranslateText text="LEARN MORE" />
        </button>
      </div>
    </div>
  );
}

export default LearnMore;




// import React from 'react'
// import './learn.css'
// function LearnMore() {
//   return (
//     <div className='learn'>
//         <div className='message'>
//         Tradelines are the smartest, fastest way to boost your credit score.
//         </div>
        
//         <div className='buttonBox'>
//           <button className='buttonLook'>LEARN MORE</button>
//         </div>
//     </div>
//   )
// }

// export default LearnMore
